import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import { useParams } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';
import ComicHero, { ComicDetail, RelatedComics } from './components/ComicContent';

export default function ComicPage() {
  const { slug } = useParams<{ slug: string }>();
  const comic = featuredComics.find((c) => c.slug === slug);

  if (!comic) {
    return (
      <>
        <SEOHead title="漫画未找到 - 虫虫漫画网" description="抱歉，您查找的漫画不存在。" />
        <Navbar />
        <main className="min-h-screen flex items-center justify-center bg-background-50">
          <div className="text-center">
            <i className="ri-emotion-sad-line text-5xl text-foreground-300 mb-4 block"></i>
            <h1 className="text-2xl font-bold font-heading text-foreground-900 mb-2">
              漫画未找到
            </h1>
            <p className="text-sm text-foreground-500 mb-6">
              该漫画可能已被移除或链接有误
            </p>
            <a
              href="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm whitespace-nowrap cursor-pointer"
            >
              返回首页
            </a>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const comicSchema = {
    '@context': 'https://schema.org',
    '@type': 'ComicSeries',
    name: comic.title,
    description: comic.summary,
    url: `https://www.chongchongmanhua.com/comic/${slug}`,
    author: {
      '@type': 'Person',
      name: comic.author,
    },
    genre: comic.tags,
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: comic.rating,
      bestRating: '10',
      reviewCount: Math.floor(comic.views / 100),
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.chongchongmanhua.com' },
        {
          '@type': 'ListItem',
          position: 2,
          name: '漫画分类',
          item: `https://www.chongchongmanhua.com/category/${comic.category}`,
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: comic.title,
          item: `https://www.chongchongmanhua.com/comic/${slug}`,
        },
      ],
    },
  };

  return (
    <>
      <SEOHead
        title={`${comic.title} - 下拉式完整版免费阅读 | 虫虫漫画网`}
        description={`${comic.title}，作者${comic.author}，${comic.summary}下拉式完整版韩国漫画免费阅读，虫虫漫画网无删减流畅观看。`}
        keywords={`${comic.title},${comic.tags.join(',')},下拉式漫画,无删减漫画,韩国漫画,虫虫漫画网`}
        canonicalUrl={`https://www.chongchongmanhua.com/comic/${slug}`}
        schema={comicSchema}
      />

      <Navbar />

      <main>
        <ComicHero slug={slug || ''} />
        <ComicDetail slug={slug || ''} />
        <RelatedComics slug={slug || ''} />
      </main>

      <Footer />
    </>
  );
}